/**
 * =========================================================
 *
 * 购物党网站webpack脚本入口
 * 首页js可以写在这里，或者单独写在/Pages中
 * 其他页面建议写在/Pages中，尽量拆分
 *
 * 接口服务写在Service中
 * 数据模型接口写在Model中
 *
 * @author wanghui@gwdang.com
 *
 *
 * =========================================================
 */

import '../css/public.css';
import '../css/module.css';
import '../css/main.css';
import '../../../css/main_2017.css';
import '../css/index.css';
import '../css/productCard.less';
import '../css/common.less';
import '../css/chart.less';

import Utils from '../js/utils/utils';
import collect from '../js/collect';

import '../js/jquery.autocomplete';
import '../../../js/jquery.lazyload';

collect.init()

const tpl = $('#tpl_now').text();
let currentTime = parseInt((new Date()).getTime() / 1000);  // 当前时间（秒）

(function() {
    let d = new Date();
    let c = localStorage.getItem('app-qr-close')
    if (!c || c.toString() !== d.getDate().toString()) {
        $('.top-app-ad').addClass('top-force-open')
    }
    $('.top-app-ad.top-force-open img.app_close').on('click', e => {
        e.preventDefault()
        $('.top-app-ad').removeClass('top-force-open')
        localStorage.setItem('app-qr-close', d.getDate())
    })
})();

// 首页折扣精选
(function() {
    var current = 1;

    function clearDots() {
        $('.dot').removeClass('active')
    }

    function setPage(page, callPage = false) {
        clearDots()
        $('.dot:nth-child(' + page + ')').addClass('active')
        if (window.setPage && callPage) {
            window.setPage(page)
        }
        $('#discountContent a:first').css('margin-left', - 170*4 * (page - 1) + 'px')
        current = page
    }

    window.setPageG = setPage

    function next() {
        if (current >= 5) {
            setPage(1)
            return
        }
        setPage(current + 1, false)
    }

    function prev() {
        if (current <= 1) {
            setPage(5)
            return
        }
        setPage(current - 1, false)
    }

    $('.dot').click(function() {
        let page = ($(this).attr('data-page'));
        setPage(parseInt(page), true)
    })
    $('#btn_next').click(next)
    $('#btn_prev').click(prev)
})()

// =========网站节日促销=========

// 底部banner
$(".closebanner").click(function (e) {
    let discount = Utils.getNextDayZeroSeconds();
    Utils.Cookies.setItem('closejd', 'true', discount, '/', '.gwdang.com');
    $(".jd618footer").fadeOut(500);
    e.preventDefault()
});

// 右上角红包
$(".img-close#close-envelope").click(function (e) {
    let discount = Utils.getNextDayZeroSeconds();
    Utils.Cookies.setItem('close_red_envelop', 'true', discount, '/', '.gwdang.com');
    $(".red-envelope").fadeOut(500);
    e.preventDefault();
});


// 右下角二维码
$('.qr-area>.qr-close').click(function () {
    let discount = Utils.getNextDayZeroSeconds();
    Utils.Cookies.setItem('closeqr', 'true', discount, '/', '.gwdang.com');
    $(this).parents('.qr-area').addClass('none')
});



// =========页面滚动处理=========
// $(window).scroll(function () {
//     let scrollTop = document.documentElement.scrollTop || window.pageYOffset || document.body.scrollTop;
//     let windowHeight = window.innerHeight;
//     let documentHeight = document.body.scrollHeight;
//
//     if ($(".jd618footer").length) {
//         let position = 'fixed',
//             margin_bottom = 0;
//         if(scrollTop + windowHeight > documentHeight - 238) {
//             position = 'relative';
//             margin_bottom = '-15px';
//         }
//         $(".jd618footer").css({
//             'position': position,
//             'margin-bottom': margin_bottom,
//         })
//     }
// });

// ============= 弹窗登录 ==============
if (! Utils.Cookies.getItem('GWD_USER_TOKEN')) {
    $('.pop_login').click(function() {
        $('#pop_mask,#pop_login').show();
    });
    $('#pop_login_close, #pop_mask').click(function() {
        $('#pop_mask,#pop_login').hide();
    });
}


// ================= 促销活动倒计时 ==========
function minusTime() {
    let nowtime = ++currentTime;
    $('.time_left').each(function() {
        let endtime = parseInt($(this).attr('end_time'));
        let leftsecond = endtime - nowtime;
        if (leftsecond > 0) {
            let __d = parseInt(leftsecond / 3600 / 24),
            __h = parseInt((leftsecond / 3600) % 24),
            __m = parseInt((leftsecond / 60) % 60),
            __s = parseInt(leftsecond % 60);
            $(this).html("距离结束时间剩：" + __d + "天 " + __h + "小时" + __m + "分" + __s + "秒");
        } else {
            $(this).html("已结束");
        }
    });
}

if ($('.time_left').length) {
    setInterval(minusTime, 1000);
}

$(document).ready(function() {
    let page = 2;
    $('#indexReplace').on('click', () => {
        $.get('/promotion/activity/0-0-0-0-' + page + '.html?format=ajax', data => {
            $('.activity-datas').html(data)
            page += 1
            if (page > 5) {
                page = 1
            }
        })
    })
})

// 翻页
let jump_to_page = function(e) {
    e.preventDefault();
    let number = parseInt($("#jump_number").val());
    let pages = parseInt($("#pages").html());
    let new_href = '';
    let queryMode = true
    if(! isNaN(number) && number <= pages){
        let href = window.location.href;
        let now_href = $('.page a.current').attr('href')
        if(now_href.match('/index/') || href.match("/quan") || href.match("activity") || href.match('lowest') || href.match('/discount')){
            new_href = now_href.replace(/-\d+.html/,function(){
                return '-'+number+'.html'
            })
            if (new_href.indexOf('-'+number+'.html') === -1) {
                new_href = now_href + '---' + number + '.html'
            }
            queryMode = false
        }
        if(href.match("zhi") || href.match("haitao") || href.match("yangmao") || href.match("coupon")){
            new_href = now_href.replace(/(\d)+[-]{3,4}\S?\.html/g,function(s){
                let length = parseInt(s).toString().length;
                return String(number) + s.slice(length);
            })
            queryMode = false
        }
        console.log('go')
        if (queryMode) {
            if (now_href.match('pg=')) {
                new_href = now_href.replace(/pg=(\d+)?/, 'pg=' + number)
            } else {
                new_href = now_href + '&pg=' + number
            }
        }
        window.location.href = new_href
    }
};

// 翻页跳转
$("div.page").keypress(function(e) {
    if(e.keyCode === 13) {
        jump_to_page(e);
    }
});
$("#jump_to_page").click(jump_to_page);


$("#gotop, .toTop").click(function(){
    $('body,html').animate({scrollTop:0},200);
});

$(function () {
    setInterval(function() {
        check()
    }, 4e3);
    let check = function() {
        function doCheck(a) {
            // if (("" + a / a)["length"] !== 1 || a % 20 === 0) {
            //     (function() {}
            //         ["constructor"]("debugger")())
            // } else {
            //     (function() {}
            //         ["constructor"]("debugger")())
            // }
            doCheck(++a)
        }
        try {
            doCheck(0)
        } catch (err) {}
    };
    // check();

    // 搜索输入联想词
    try {
        $("#header_search_input").autocomplete({
            'url': '/suggest.php',
            'useCache': false,
            'filterResults': false,
            'sortResults': false
        });

    } catch (e) {}

    /*image lazyload*/
    $('.pingjiaList .pingjia_info img.lazy').lazyload();
    $('.cuxContenList .cuxContL .pic img.lazy').lazyload();
    $('#tab_where_buy img.lazy').lazyload();
    $('img.lazy').lazyload();

    // =========顶部全部分类=========
    let category = $(".category.category_hover");
    category.remove();

    if (location.pathname !== '/') {
        let menu = $('.kinds_menu');
        let menu_hover = null;

        if (menu.length === 1 ) {
            menu_hover = menu;
            menu.append(category);
        } else {
            menu = $('#newMenuWrap');
            menu_hover = $('a.undN');
            menu.append(category);
            $(".category").css('top',44);
        }

        menu_hover.children('a.undN').hover(function () {
            category.addClass('hovered').show()
        },function () {
            category.hasClass('hovered') && category.removeClass('hovered').hide();
        });
    }

    category.hover(function () {
        $(this).addClass('hovered').show()
    }, function () {
        $(this).removeClass('hovered').hide()
    });

    let header_hover = function () {
        let index = $(this).attr('index');
        $(".category_content .category_content_detail[index="+index+"]").show();
    };

    let header_out = function () {
        let index = $(this).attr('index');
        $(".category_content .category_content_detail[index="+index+"]").hide();
    };

    $(".category_header p, .category_content .category_content_detail").hover(header_hover, header_out);
});


// ================= 各个栏目用到的分类、品牌、属性等的筛选 ======================
if ($('.filter-wrapper').length) {
    require('../Pages/Search/filter')
}





// ------------------------------------------------------------------------------------------
// 下面是各个栏目和页面的处理（也可单独新建一个js文件引用）
// ---------------------------------------------------------------------------------------------


//首页



if (tpl === 'baoliao') {
    if (-1 === document.cookie.lastIndexOf('index_big_banner')) {
        let date = new Date();
        let expiresDays = 360;
        date.setTime(date.getTime() + expiresDays * 24 * 3600 * 1000);
        document.cookie = 'index_big_banner=1;expires=' + date.toGMTString();
        $('.banner_index').css({height: ''});
        $('#baoliaoNewR').find('.download_old').hide();

        $('.banner_index #area1').click(function() {
            $('.banner_index').animate({
                'height': '0'
            }, 500);
            $('#baoliaoNewR').find('.download_old').show();
        });
    }

    if (banner) {
        if (currentTime > banner.start_time && currentTime < banner.end_time && document.cookie.indexOf('closejd=true') === -1) {
            $(".jd618footer").show()
        } else {
            $(".jd618footer").remove()
        }
    }
}


// ========= 促销活动栏目 =========
if (tpl === 'promotion_activity') {
    // 左侧悬浮菜单
    $('.cuxBox .top dl').mouseenter(function() {
        $(this).addClass('hover').siblings().removeClass('hover');
        $('.cuxBox').animate({
            width: '726px'
        }, 150);
        $('.cuxBox .top dd').hide();
        $(this).find('dd').show();
    });
    $('.cuxBox .top').mouseleave(function() {
        $('.cuxBox').animate({
            width: '114px'
        }, 150);
        $('.cuxBox .top dl').removeClass('hover')
    })
}


// ========= 比价单品页 =========
if (tpl === 'product') {
    require("../Pages/Product/index")
}

if (tpl === 'product_middlepage') {
    require("../Pages/Product/index")
    require("../Pages/ProductMiddlepage/index")
}

// 历史价格查询
if(tpl === 'trend') {
    require("../Pages/Product/index")
}

if (tpl === 'product_show_wechat') {
    require("../Pages/Product/priceProtect")
}

if (tpl === 'mine_price_protect') {
    require("../Pages/Product/priceProtect")
}

if (tpl === 'trend_steam') {
    require("../Pages/Trend/steam")
}

if (tpl === 'monitor_add') {
    require('../Pages/PriceMonitor/index')
}

if (tpl === 'search') {
    require("../Pages/Search/index")
}
